@if (data$ | async; as data) {
    <div
        class="aimo-background"
        [class]="getBgClass(data)"></div>
    <div class="container">
        <div class="aimo-text-banner">
            <p [innerHTML]="data.text">{{ data.text }}</p>
            @if (data.urlLink) {
                @if (data.buttonName && isExternal(data)) {
                    <a
                        class="btn"
                        [ngClass]="{
                            'btn-highlighted': data.backgroundColor === 'PETROL',
                            'btn-primary': data.backgroundColor !== 'PETROL',
                        }"
                        (click)="gtmEvent(data)"
                        [innerHTML]="data.buttonName"
                        [href]="getSafeUrl(data)"
                        [target]="getTarget(data)">
                    </a>
                }
                @if (data.buttonName && !isExternal(data)) {
                    <a
                        class="btn"
                        [ngClass]="{
                            'btn-highlighted': data.backgroundColor === 'PETROL',
                            'btn-primary': data.backgroundColor !== 'PETROL',
                        }"
                        (click)="gtmEvent(data)"
                        [innerHTML]="data.buttonName"
                        [routerLink]="data.urlLink"
                        [fragment]="data.urlLinkFragment">
                    </a>
                }
            }
        </div>
    </div>
}
